import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types'

import {
  formContainer,
  titleContainer,
  secondaryTitle,
  buttonContainer
} from './styles/LoginForm.style'

import { Button } from '../shared/styles/Button.style'
import Input from '../shared/Input'

import * as validators from '../../utils/validators'

const ForgoteMyPasswordForm = ({
  handleSubmit,
  onSubmit,
  userPhrase,
  isSubmiting,
  token,
  translation,
  lang
}) => {
  const required = lang === 'pt-BR' ? validators.requiredPT : validators.requiredES
  const passwordLength = lang === 'pt-BR' ? validators.passwordLengthPT : validators.passwordLengthES
  const passwordConfirmation = lang === 'pt-BR' ? validators.passwordConfirmatioPT : validators.passwordConfirmatioES
  return (
    <form className={formContainer} onSubmit={handleSubmit(onSubmit)}>
      <header className={titleContainer}>
        <h2 className={secondaryTitle}>Utilize seu E-mail ou Fractal ID</h2>
      </header>

      <div>
        {!token && (
          <Field
            name='fractal_id'
            type='hidden'
            component='input'
          />
        )}

        {!token && (
          <Field
            name='fractal_id'
            type='hidden'
            component='input'
          />
        )}

        {!token && (
          <div>
            <Field
              name='secret_answer'
              placeholder={`${translation('resetPassword')['secretQuestion']}: ${userPhrase.name}`}
              type='text'
              block
              validate={[required]}
              component={Input}
            />
          </div>
        )}

        <div>
          <Field
            name='password'
            placeholder={translation('resetPassword')['passwordPlaceholder']}
            type='password'
            block
            validate={[required, passwordLength]}
            component={Input}
          />
        </div>

        <div>
          <Field
            name='passwordConfirmation'
            placeholder={translation('resetPassword')['confirmPasswordPlaceholder']}
            type='password'
            block
            validate={[required, passwordConfirmation]}
            component={Input}
          />
        </div>
      </div>

      <div className={buttonContainer}>
        <Button
          type='submit'
          disabled={isSubmiting}
        >
          {translation('resetPassword')['sendButton']}
        </Button>
      </div>
    </form>
  )
}

ForgoteMyPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  userPhrase: PropTypes.object,
  token: PropTypes.string,
  isSubmiting: PropTypes.bool.isRequired,
  translation: PropTypes.func,
  lang: PropTypes.string
}

const mapStateToProps = ({ passwordRecovery }, { token }) => {
  const fractalId = passwordRecovery.login ? { fractal_id: passwordRecovery.login } : {}
  const tokenData = token ? { token: token } : {}
  const formValues = {
    ...fractalId,
    ...tokenData
  }

  return {
    userPhrase: passwordRecovery.userPhrase,
    isSubmiting: passwordRecovery.isSubmiting,
    initialValues: formValues
  }
}

const mappedConnect = connect(mapStateToProps)
const mappedReduxForm = reduxForm({
  form: 'resetPassword'
})

export default mappedConnect(mappedReduxForm(ForgoteMyPasswordForm))
